export function slippageBpsToPercent(bps: number): number {
  return bps / 100
}
